import { render, staticRenderFns } from "./dynamics.vue?vue&type=template&id=8c14cd0a&scoped=true"
import script from "./dynamics.vue?vue&type=script&lang=js"
export * from "./dynamics.vue?vue&type=script&lang=js"
import style0 from "./dynamics.vue?vue&type=style&index=0&id=8c14cd0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c14cd0a",
  null
  
)

export default component.exports